export function capitalize(str) {
  const lower = str.toLowerCase();
  const split = lower
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join(' ');
  return split;
}
